import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Select the "Jump to the top" link
const jumpToTopLink = document.getElementById('jump-to-top');

// Add a click event listener 
jumpToTopLink.addEventListener('click', function(event) {
  event.preventDefault(); // Prevent default link jump behavior

  // Perform smooth scrolling to the top
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});

// Select the footer element
const footer = document.querySelector('.footer');

// Add scroll event listener
window.addEventListener('scroll', () => {
  if (window.scrollY > 2000) { // Check if there's any scrolling
    footer.classList.add('show'); // Show the footer
  } else {
    footer.classList.remove('show'); // Hide if at the top
  }
});
